/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import UncontrolledTextInput from 'app/components/common/UncontrolledTextInput.jsx';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';

class ShortenerDetailCustom extends React.Component {
    render() {
        let panelContent = null,
            credError = null,
            name = (this.props.data && this.props.data.name) ? this.props.data.name : '',
            url = (this.props.data && this.props.data.url) ? this.props.data.url : '',
            constants = this.props.app.config.constants,
            defaultLabel = "Use this as the default when sharing manually or setting up new automated sharing.";

        if (this.props.user.detail.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
            defaultLabel = "Use this as the default when sharing manually or the default shortener for new socials.";
        }

        return (
            <div>
                <fieldset>
                    <legend>Name <span className="required">*</span></legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SHORTENER_UPDATE', 'SHORTENER_CREATE']}
                        render={(state) => {
                            return (
                                <FieldError field="name" errors={state.errors}/>
                            );
                        }}/>
                    <UncontrolledTextInput className="text-input med" defaultValue={name} onChange={this.props.requestChange} data-field="data.name"/>
                </fieldset>
                <fieldset>
                    <legend>Shortener Endpoint <HelpButton which="customShortener"/><span className="required">*</span></legend>
                    <ErrorModule
                        app={this.props.app}
                        keys={['SHORTENER_UPDATE', 'SHORTENER_CREATE']}
                        render={(state) => {
                            return (
                                <div>
                                    <FieldError field="url" errors={state.errors}/>
                                    <FieldError field="creds" errors={state.errors}/>
                                </div>
                            );
                        }}/>
                    <UncontrolledTextInput className="text-input seventyfive" defaultValue={url} onChange={this.props.requestChange} data-field="data.url"/>
                    <div className="help-text">
                        Use @URL@ as the placeholder for URL to be shortened. For instance: http://myshortener.com/shorten?url=@URL@
                    </div>
                </fieldset>
                <fieldset>
                    <legend>Default</legend>
                    <Toggle
                        active={this.props.convertValueForToggle(this.props.data.default)}
                        callback={this.props.update}
                        linkedField="data.default"
                        noLabel={true}
                        toggleClass="inline" />
                    <span className="form-inline-label light">{defaultLabel}</span>
                </fieldset>
                <fieldset>
                    <legend>Send dlvr.it links to custom shortener<HelpButton which="linkWrapper"/></legend>
                    <Toggle
                        active={this.props.convertValueForToggle(this.props.data.wrap)}
                        callback={this.props.update}
                        linkedField="data.wrap"
                        noLabel={true}
                        toggleClass="inline" />
                    <span className="form-inline-label light">Use this option to send a dlvr.it link to your shortener.</span>
                </fieldset>
                {this.props.getApplyButtons()}
                {this.props.getSaveButtons()}
            </div>
        );
    }

};

export default ShortenerDetailCustom;
